import { useEffect, useReducer } from "react";

import {
	clampTimeoutDelay,
	isOfferCacheExpired,
	offerDeadlineMs,
	OfferDeadlineSource,
} from "../utils/ordersHotPath";

/**
 * Истёк ли оффер заказа. Если дедлайн ещё впереди, взводит один
 * `setTimeout` ровно на него и перерисовывает только эту ячейку, а не
 * ждёт следующего события подписки. Без дедлайна таймер не ставится.
 */
export default function useOfferExpired(
	item: OfferDeadlineSource | null | undefined,
): boolean {
	const deadline = offerDeadlineMs(item);
	const [, bump] = useReducer((tick: number) => tick + 1, 0);

	useEffect(() => {
		if (typeof deadline !== "number") return undefined;
		let handle: ReturnType<typeof setTimeout> | null = null;
		const arm = () => {
			const delay = deadline - Date.now();
			if (delay <= 0) {
				handle = null;
				bump();
				return;
			}
			// часы могли шагнуть назад (NTP, сон) — перевзвестись, а не
			// остаться с синим позывным до следующего события
			handle = setTimeout(arm, clampTimeoutDelay(delay + 1));
		};
		if (deadline - Date.now() <= 0) return undefined;
		arm();
		return () => {
			if (handle != null) clearTimeout(handle);
		};
	}, [deadline]);

	return isOfferCacheExpired(item);
}
